<div class="code-designations-container">
    <div class="code-designations-item-container">
        <div class="code-designations-item-input-container">
            <mat-form-field appearance="outline" class="code-designations-form-field">
                <mat-label>{{ formFieldTitle }}</mat-label>
                <input matInput #codeDesignationsInput [(ngModel)]="codeDesignations" class="code-designations code-designations-item-input"
                (keyup.enter)="updateCodeDesignations($event)" (keyup.escape)="cancelUpdate()" (blur)="updateCodeDesignations($event)" />
                <mat-icon matSuffix class="code-designations-trailing-icon" (mousedown)="clearCodeDesignationsInputField()">cancel</mat-icon>
            </mat-form-field>
        </div>
        <div class="input-error" *ngIf="hasFieldValidationError(formFieldName)">
            This is a required field.
        </div>
    </div>
    <div *ngIf="formType !='FormC'" class="code-designations-info code-designations-info-text">
        Please list all current and former codes.
    </div>
    <div *ngIf="formType === 'FormC'" class="code-designations-info code-designations-info-text">
        List any changes or additions to the code designations since the first USAN was adopted.
    </div>
</div>